import { Controller } from 'stimulus';
import { templateContent } from '@/js/util';

const SHELL_ID = 'twin_turbo_modal_shell';

export default class extends Controller {
  static values = {
    frame: String,
    title: String,
    url: String,
  };

  open(event) {
    event.preventDefault();

    const shell = document.getElementById(SHELL_ID);

    if (!shell) {
      throw new Error(`render UI::TwinTurboModal::Shell to open #${this.frameValue}`);
    }

    const modal = templateContent(shell);
    const frame = modal.querySelector('turbo-frame');

    modal.setAttribute('aria-label', this.titleValue);
    modal.querySelector('h2').textContent = this.titleValue;
    frame.id = this.frameValue;
    frame.setAttribute('src', this.urlValue || this.element.href);

    document.body.append(modal);
  }
}
